<template>
  <div class="convey-home-page d-flex align-items-center justify-content-center px-2 py-2 px-md-4 py-md-4">
    <Hero />
  </div>
</template>

<script>
/* eslint-disable */
import Hero from "@/components/Hero";
import { mapGetters } from "vuex";

export default {
  name: "ConveyHome",
  components: { Hero },
  computed: {
    ...mapGetters("agency", ["agencyModules", "currentAgency", "lastSelectedModule"]),
  },
  created() {
    this.$store.commit("agency/setSelectedAgencyModule", null);
  },
  watch: {
    agencyModules: {
      handler(modules) {
        if (modules && modules.length > 0) {
          if (this.currentAgency && this.currentAgency.agency_id && this.lastSelectedModule[this.currentAgency.agency_id]) {
            const lastSelectedModule = this.lastSelectedModule[this.currentAgency.agency_id];
            const existInModules = modules.find(i => i.setting === lastSelectedModule.setting);
            if (existInModules) {
              this.$router.push({ name: lastSelectedModule.routeName }).catch(() => {});
            } else {
              this.$router.push({ name: modules[0].routeName }).catch(() => {});  
            }
          } else {
            this.$router.push({ name: modules[0].routeName }).catch(() => {});
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.convey-home-page {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>
